
import { curryFactory } from '~/utils/tools.js'
export default {
  name: 'ScenceMoreShow',
  data() {
    const createObject = curryFactory('title', 'desc')
    return {
      gapCol: '30px',
      dataList: [
        createObject(
          '支持大量用户同时答题',
          '如您需要同一时间大规模发放问卷，问卷网有大量高并发项目经验，尽可放心选择',
          {
            icon: require('~/assets/image/scence/survey/showmorw01.png'),
            width: '52px',
            height: 'auto',
          }
        ),
        createObject(
          '数据长期保存',
          '无需担心数据丢失问题，历史数据我们也会长期保存在云端供您随时免费下载使用',
          {
            icon: require('~/assets/image/scence/survey/showmorw02.png'),
            width: '52px',
            height: '40px',
          }
        ),
        createObject(
          '不限制答题人数',
          '适合进行大规模的社会化调研，无需担心数量限制问题',
          {
            icon: require('~/assets/image/scence/survey/showmorw03.png'),
            width: '46px',
            height: '45px',
          }
        ),
        createObject(
          '引导关注公众号',
          '可开通用户关注公众号之后才能答题功能，让你的微信公众号快速涨粉',
          {
            icon: require('~/assets/image/scence/survey/showmorw04.png'),
            width: '47px',
            height: '46px',
          }
        ),
        createObject(
          '微信红包',
          '通过微信红包吸引答题人，快速获得大量参与者，增加问卷曝光',
          {
            icon: require('~/assets/image/scence/survey/showmorw05.png'),
            width: '49px',
            height: '43px',
          }
        ),
        createObject(
          '100多种免费精品主题',
          '根据企业主色调或节日选择合适的主题，亦可自定义色系、上传品牌logo',
          {
            icon: require('~/assets/image/scence/survey/showmorw06.png'),
            width: '51px',
            height: '40px',
          }
        ),
      ],
    }
  },
  computed: {
    isMobile() {
      return this.$store.state.isMobile
    },
  },
  mounted() {},
  methods: {
    change({ width, maxWidth }) {
      if (width < this.$pointWidth) {
        this.gapCol = '15'
      }
    },
  },
}
